import { ADMIN_ROUTE_PATHS } from '@oneComply/core/constants/admin-route-paths';

export interface AdminNavItem {
  path: string;
  label: string;
  icon: string;
  companyAdminOnly?: boolean;
}

export interface AdminNavSection {
  id: string;
  label: string;
  items: AdminNavItem[];
}

export const ADMIN_NAV_SECTIONS: AdminNavSection[] = [
  {
    id: 'management',
    label: 'Gestão',
    items: [
      { path: ADMIN_ROUTE_PATHS.dashboard, label: 'Dashboard', icon: 'speedometer2' },
      { path: ADMIN_ROUTE_PATHS.notifications, label: 'Notificações', icon: 'bell' },
      {
        path: ADMIN_ROUTE_PATHS.activityLogs,
        label: 'Auditoria',
        icon: 'clock-history',
        companyAdminOnly: true,
      },
      {
        path: ADMIN_ROUTE_PATHS.users,
        label: 'Usuários',
        icon: 'people',
        companyAdminOnly: true,
      },
      { path: ADMIN_ROUTE_PATHS.activeReports, label: 'Denúncias em andamento', icon: 'flag' },
      { path: ADMIN_ROUTE_PATHS.archivedReports, label: 'Denúncias arquivadas', icon: 'archive' },
      { path: ADMIN_ROUTE_PATHS.categoriesList, label: 'Categorias', icon: 'tags' },
    ],
  },
  {
    id: 'settings',
    label: 'Configurações',
    items: [
      { path: ADMIN_ROUTE_PATHS.profile, label: 'Perfil', icon: 'person' },
      {
        path: ADMIN_ROUTE_PATHS.settings,
        label: 'Configurações',
        icon: 'gear',
        companyAdminOnly: true,
      },
    ],
  },
];
